import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * The desks write markdown, so links, lists and code survive the trip.
 *
 * Two things are load-bearing here.
 *
 * react-markdown does NOT render raw HTML unless you add rehype-raw, and we
 * deliberately do not. Card text comes from a desk that in turn relays what people
 * typed in Telegram, so it is not trusted input, and the safest way to handle HTML in
 * it is to never parse it at all.
 *
 * Links open in a new tab with rel="noreferrer" — a card links out to a sheet or a
 * ticket, and following it should not replace the board you were reading.
 */
export function Markdown({ children, inline = false }: { children: string; inline?: boolean }) {
  return (
    <div className={inline ? 'md md-inline' : 'md'}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ node: _node, ...props }) => (
            <a {...props} target="_blank" rel="noreferrer noopener" />
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
